export default __webpack_public_path__ + "static/media/Letrero principal reocortado.0480a740.png";